import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

export interface ReleaseNote {
  id: string;
  version: string;
  title: string;
  content: string;
  published_at: string;
  created_by: string;
  created_by_name: string;
  created_at: string;
  updated_at: string;
  is_public: boolean;
}

export interface CreateReleaseNoteInput {
  content: string;
  is_public?: boolean;
}

export interface UpdateReleaseNoteInput {
  content?: string;
  is_public?: boolean;
}

export async function getAllReleaseNotes(token: string): Promise<ReleaseNote[]> {
  const response = await axios.get(`${API_BASE_URL}/release-notes`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function getReleaseNote(id: string, token: string): Promise<ReleaseNote> {
  const response = await axios.get(`${API_BASE_URL}/release-notes/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function getNextVersion(token: string): Promise<string> {
  const response = await axios.get(`${API_BASE_URL}/release-notes/next-version`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data.version;
}

export async function createReleaseNote(data: CreateReleaseNoteInput, token: string): Promise<ReleaseNote> {
  const response = await axios.post(`${API_BASE_URL}/release-notes`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function updateReleaseNote(id: string, data: UpdateReleaseNoteInput, token: string): Promise<ReleaseNote> {
  const response = await axios.put(`${API_BASE_URL}/release-notes/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function deleteReleaseNote(id: string, token: string): Promise<void> {
  await axios.delete(`${API_BASE_URL}/release-notes/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
